export var ROUTES_PATHS;
(function (ROUTES_PATHS) {
    ROUTES_PATHS["CONFIGURATION"] = "configuration/:selectedObjectId?";
    ROUTES_PATHS["STATISTIC"] = "statistic/:selectedObjectId?";
    ROUTES_PATHS["STARTING_PAGE"] = "starting-page";
    ROUTES_PATHS["ERROR_PAGE"] = "error";
    ROUTES_PATHS["OBJECTS_DIAGRAMS"] = "objects-diagrams";
})(ROUTES_PATHS || (ROUTES_PATHS = {}));
export var PATHS_VALUES;
(function (PATHS_VALUES) {
    PATHS_VALUES["CONFIGURATION"] = "/configuration";
    PATHS_VALUES["STATISTIC"] = "/statistic";
    PATHS_VALUES["STARTING_PAGE"] = "/starting-page";
    PATHS_VALUES["DEFAULT_PAGE"] = "/";
    PATHS_VALUES["ERROR_PAGE"] = "/error";
    PATHS_VALUES["DIAGRAMS_PAGE"] = "/objects-diagrams";
})(PATHS_VALUES || (PATHS_VALUES = {}));
